import { jsx as _jsx } from "react/jsx-runtime";
var Icon = function Icon(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3.125L7.53333 0L15.0667 3.125C15.0667 11.625 11.0863 13.975 7.53333 16C3.98038 13.975 0 11.625 0 3.125ZM4.76856 9.09998C5.29616 9.62498 5.82376 10.15 6.35804 10.675C8.22801 8.89998 10.0446 7.17498 11.8611 5.42498C11.5673 5.17498 11.3001 4.94998 11.033 4.72498C11.0024 4.74407 10.9796 4.75952 10.9601 4.77272C10.9285 4.79407 10.9057 4.80952 10.8727 4.82498C10.2049 5.28746 9.53035 5.7562 8.85584 6.22494C8.1813 6.6937 7.50675 7.16246 6.83889 7.62498C6.60195 7.78512 6.48176 7.86635 6.36007 7.86867C6.2348 7.87106 6.10793 7.78983 5.85047 7.62498C5.61937 7.47049 5.38373 7.31601 5.14543 7.15978C4.80526 6.93677 4.45966 6.71019 4.11407 6.47498C3.95378 6.64998 3.80018 6.82498 3.64657 6.99998C3.49296 7.17498 3.33936 7.34998 3.17908 7.52498C3.71336 8.04998 4.24096 8.57498 4.76856 9.09998Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default Icon;